import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{this.i18nCount}}",{ moduleName: "discourse/components/count-i18n.hbs" })